
export const ServiceURLConstants: any = {
    GET_INIT: "/upplm/Init",
    GET_UPPLM_SESSION: "/upplm/getSessionInfo",
    SET_UPPLM_SESSION: "/upplm/setSessionInfo",
    GET_LOCATIONS: "/upplm/addressSearch",
    GET_HTML_CONTENT: '/upplm/content/GetLookup',
    CREATE_SESSION: "/upplm/createSession",
    CLEAN_SESSION: "/upplm/cleanSession",
    GET_PLACARD_OPTIONS: "/upplm/getPlacardOptions",
    GET_UPPLM_PICKUP_DETAILS: "upplm/pickupDetails",
    GET_CAPTCHA_PUBLIC_KEY: "/upplm/captchaPublicKey",
    CREATE_PICKUP: "/upplm/createPickup",
    IS_PLACARD_CONFIRMED: "/upplm/isplacardconfirmed",
    CREATE_PLACARD_CONFIRMATION: "/upplm/uploadFilePlacardConfirmation",
    PLACARD_LOCATION_DETAILS_CONFIRMATION: "/upplm/PlacardLocationDetailsConfirmation/",
    GET_CATALOG: "/upplm/GetCatalogPlacardLocationDetails",
    GET_PLACARD_CONFIRMATION_STATUS: "upplm/getPlacardConfirmationStatus",
    GET_PLACARD_VERIFICATION: "upplm/placardpending",
    GET_PLACARD_INFORMATION: 'upplm/getPlacardInformation/',
    SEND_APPROVE: 'upplm/sendApprove/',
    GET_DASHBOARD_INFORMATION: 'upplm/getDashboardInformation',
    GET_VALIDATION_CLIENT_KEY_ID: 'upplm/getValidationClientKeyId',
    GET_CLIENT_KEY_MATCH: 'upplm/getKeyMatch',
    VALIDATE_CAPTCHA: 'upplm/validateCaptcha',
    ADD_CLIENT_KEY: 'upplm/addClientKey',
    GET_QVSUMMARIES: 'upplm/summaries',
    GET_QVSUMMARIES_COOKIES: 'upplm/summariesCookies',
    GET_QVLIST: 'upplm/getQVList',
    GET_CONFIGURATION: 'upplm/getConfiguration',
    GET_FILE_EXCEL_OR_EMAIL: 'upplm/getFileExcelOrEmail',
    GET_TRANSLATIONS: 'upplm/getTranslations',
    GET_PICKUP_PLAN: 'upplm/getPickupPlan',
    GET_COMMON_USER_ATTRIBUTES: 'upplm/getCommonUserAttributes',
    EDIT_PLACARD: 'upplm/editPlacard',
    GET_PLACARD_CATALOG: 'upplm/getPlacardCatalog'
}
export const RouteURLConstants: any = {
    UPPLM_VIEW_PLACARD_PLACARD_ADD_CLIENT_KEY: "placardaddclientKey",
    UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE: "locationdetails",
    UPPLM_VIEW_CONTACT_DETAILS_ROUTE: "contactdetails",
    UPPLM_VIEW_PLACARD_DETAILS_ROUTE: "placarddetails",
    UPPLM_VIEW_PLACARD_LOCATION_ROUTE: "placardlocation",
    UPPLM_VIEW_PICKUP_DETAILS_ROUTE: "pickupdetails",
    UPPLM_VIEW_NOTIFICATION_DETAILS_ROUTE: "notificationdetails",
    UPPLM_VIEW_REVIEW_ROUTE: "locationpending",
    UPPLM_VIEW_CONFIRMATION_ROUTE: "locationcreated",
    UPPLM_VIEW_PLACARD_EXISTS_ROUTE: "placardexists",
    UPPLM_VIEW_PLACARD_CONFIRMED_ROUTE: "placardconfirmed",
    UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE: "placardpending",
    UPPLM_VIEW_APPROVE_ROUTE: "approve",
    UPPLM_VIEW_DASHBOARD_ROUTE: "dashboard",
    UPPLM_VIEW_QVSUMMARY_ROUTE: "qvsummary",
    UPPLM_VIEW_APPROVE_CONFIRMED_ROUTE: "approveconfirmed",
    UPPLM_VIEW_PLACARD_EXISTS_CONFIRMATION_ROUTE: "placardexistsconfirmation",
    CV_QUANTUM_VIEW: "/cv",
    MAIN_ROUTE: "mcba",
    CV_CREATE_INBOUND_LID: "/cv/addlocation",
    TECHNICAL_PAGE: '/cv/technicalerror',
    CV_INFO_PAGE: "/cv/info",
    CV_NOT_SELF_ENROLL: "/cv/notselfenroll",
    CV_VIEW_CLAIMS_ROUTE: "#/cv/viewclaims",
    CV_VIEW_OUTBOUND_ROUTE: "/cv/viewoutbound",
    CV_VIEW_INBOUND_ROUTE: "/cv/viewinbound",
    CV_VIEW_INBOUND_REC_ROUTE: "/cv/viewinboundreceving",
    CV_VIEW_THIRD_ROUTE: "/cv/viewthirdparty",
    CV_VIEW_IMPORT_ROUTE: "/cv/viewimport",
    CV_CREATE_IRA: "/cv/addira",
    CV_OUT_CONFIRMATION: "/cv/confirmation",
    CV_SELF_INBOUND: "/cv/selfenrollinbound",
    CV_USER_ADMIN: "/cv/useradmin",
    CV_CREATE_USER: "/cv/createuser",
    CV_OUTBOUND_COMPANY: "/cv/info/qvo",
    CV_EDIT_INBOUND_ROUTE: "/cv/editinbound",
    CV_AGV_INFO: "/cv/avginfo",
    CV_CHOOSE_IRA: "/cv/chooseira",
    CV_CHOOSE_ACCOUNT: "/cv/chooseaccount",
    MCBA_UPS_DOT_COM_URL: "https://www.ups.com/mcba",
    DOAPP_OPEN_ACCOUNT_ROUTE: "https://www.ups.com/doapp/signupopenaccount?loc=",
    GET_UPPLM_PICKUP_DETAILS: "UPPLM_PD",
    CV_DOAPP_CLIENT_ID: "&clientId=17",
    CV_RETURN_TO: "&returnTo=",
    DOAPP_ADD_EXISTING_ACCOUNT_ROUTE: "https://www.ups.com/doapp/addexistingaccount?loc=",
    RETURN_URL_VIEW_OUTBOUND: "#/cv/viewoutbound",
    RETURN_URL_VIEW_THIRD_PARTY: "#/cv/viewthirdparty",
    RETURN_URL_VIEW_CLAIMS: "#/cv/viewclaims"
}
export const UTagConstants: any = {
    COMPLETION_EVENT: '0165',
    EVENT_99: '99',
    EVENT_29: '29',
    FORM_INTENT_Y: 'y',
    UPPLM: "UPPLM",
    UPPLM_SERVICES: "services",
    UPPLM_LOCATION_DETAILS_START: "UPPLM_LocationDetails",
    PAGE_LOCATION_DETAIL: "LocationDetail",
    UPPLM_LOCATION_DETAILS_START_SCREEN: 'screen_upplm_location_detail_start',
    UPPLM_CONTACT_DETAILS_START: "UPPLM_ContactDetails",
    PAGE_CONTACT_DETAIL: "ContactDetails",
    UPPLM_CONTACT_DETAILS_START_SCREEN: 'screen_upplm_contact_detail_start',
    UPPLM_PLACARD_DETAILS_START: "UPPLM_PlacardDetails",
    PAGE_PLACARD_DETAIL: "PlacardDetails",
    UPPLM_PLACARD_DETAILS_START_SCREEN: 'screen_upplm_placard_detail_start',
    UPPLM_PICKUP_DETAILS_START: "UPPLM_PickupDetails",
    PAGE_PICKUP_DETAIL: "PickupDetails",
    UPPLM_PICKUP_DETAILS_START_SCREEN: 'screen_upplm_pickup_detail_start',
    UPPLM_NOTIFICATION_START: "UPPLM_NotificationDetails",
    PAGE_NOTIFICATION_DETAIL: "NotificationDetails",
    UPPLM_NOTIFICATION_DETAILS_START_SCREEN: 'screen_upplm_notification_detail_start',
    UPPLM_REVIEW_START: "UPPLM_Review",
    PAGE_REVIEW: "Review",
    UPPLM_REVIEW_START_SCREEN: 'screen_upplm_review_start',
    UPPLM_CONFIRMATION_START: "UPPLM_Confirmation",
    PAGE_CONFIRMATION: "Confirmation",
    UPPLM_CONFIRMATION_START_SCREEN: 'screen_upplm_confirmation_start',
    UPPLM_PLACARD_EXIST_START: "UPPLM_PlacardExists",
    PAGE_PALACARD_EXIST: "PlacardExists",
    UPPLM_PLACARD_EXIST_START_SCREEN: 'screen_upplm_placard_exist_start'
}
export const UTagPageIds: any = {
    CONFIRMATION_PAGE: "ct1_doapp_confirm_cvenrollment",
    CHOOSE_ACCOUNT: "ct1_doapp_cvchooseaccount",
    CV_OPTION: "ct1_doapp_cvoptions",
    CHOOSE_ADDRESS: "ct1_doapp_cvchooseaddress",
    COMPANY_INFO: "ct1_ppc_preferences_commercialvisibility",
    CREATE_IRA: "ct1_ppc_preferences_commercialvisibility_createinboundaddress",
    CREATE_LID: "ct1_ppc_preferences_commercialvisibility_createinboundlocation",
    CREATE_USER: "ct1_ppc_preferences_commercialvisibility_createuser",
    EDIT_ACCOUNT_PRIVILEGE: "ct1_ppc_preferences_commercialvisibility_editaccountprivileges",
    EDIT_LOCATION_PRIVILEGE: "ct1_ppc_preferences_commercialvisibility_editlocationprivileges",
    INVITE_USER: "ct1_ppc_preferences_commercialvisibility_inviteuser",
    NOT_ENROLL: "ct1_ppc_preferences_commercialvisibility_notenroll",
    SELF_ENROLL_INBOUND: "ct1_doapp_enteraddress_selfenrollinbound",
    UPDATE_NICKNAME: "ct1_ppc_preferences_commercialvisibility_updatedisplayname",
    USER_ADMIN: "ct1_ppc_preferences_commercialvisibility_useradmin",
    VIEW_OUTBOUND: "ct1_ppc_preferences_commercialvisibility_outbound",
    VIEW_THIRDPARTY: "ct1_ppc_preferences_commercialvisibility_thirdparty",
    VIEW_IMPORTS: "ct1_ppc_preferences_commercialvisibility_imports",
    VIEW_INBOUND: "ct1_ppc_preferences_commercialvisibility_inbound",
    VIEW_CLAIMS: "ct1_ppc_preferences_commercialvisibility_cliams"
}
export const ConfirmationFlowConstants: any = {
    OUTBOUND_FLOW: 'selfEnrollOutbound',
    IRA_FLOW: 'selfEnrollIRA',
    SESSION_TEMED_OUT_TITLE: 'Your session has timed out. Please try again.',
    SERVICE_ERROR: 'We cannot submit your request at this time. Please try again later.'
}
export const WEMSLookupConstants: any = {
    CAC_CONTENT: 'ct1_cac_content',
    CV_COMPANY_INFO: "cv_pref_compayinfo_text",
    CV_ACCORDIAN_TEXT: "cv_pref_accordian_text",
    CV_COMMON_TEXT: "cv_pref_common_text",
    CV_ERROR_LIST_WEM: "cv_pref_errors",
    CV_COMP_SERVICES: "cv_pref_comp_services_text",
    CV_SELF_ENROLL: "cv_pref_selfenroll_text",
    CV_USERS: "cv_users_text",
    CV_SHOWHIDE: "cv_showhide"
}
export const CommonConstants: any = {
    UPPLM_DEFAULT_LOCALE: "en_US",
    ORDERED_DAYS_OF_WEEK: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    SHORT_ORDERED_DAYS_OF_WEEK: [
        'Mon.',
        'Tue.',
        'Wed.',
        'Thur.',
        'Fri.',
        'Sat.'
    ],
    SHORT_ORDERED_DAYS_OF_WEEK_WITHOUT_POINT: [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    SHORT_ORDERED_UPPER_DAYS_OF_WEEK: [
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT'
    ],
    DAYS_OF_WEEK_WITH_SHORT_KEY: [
        {
            short: 'MON',
            dayOfWeek: 'Monday'
        },
        {
            short: 'TUE',
            dayOfWeek: 'Tuesday'
        },
        {
            short: 'WED',
            dayOfWeek: 'Wednesday'
        },
        {
            short: 'THU',
            dayOfWeek: 'Thursday'
        },
        {
            short: 'FRI',
            dayOfWeek: 'Friday'
        },
        {
            short: 'SAT',
            dayOfWeek: 'Saturday'
        },
    ],
    CV_GENERIC_ERROR: "cvGenericError",
    CV_TRANSIENT: "Transient",
    CV_HARD: "Hard",
    CV_EXCEPTION: "Exception",
    CV_CAC_INVALID_ADDRESS: "0",
    CV_CAC_VALID_ADDRESS: "2",
    CV_CAC_AMBIG_ADDRESS: "3",
    CV_ERROR_CODE: 'ErrorCode',
    CV_ERROR_MESSAGE: 'ErrorMessage',
    CV_OUBOUND_CODE: "qvo",
    CV_IMPORT_CODE: "qvb",
    CV_THIRD_PARTY_CODE: "qv3",
    CV_INBOUND_LID_CODE: "qvl",
    CV_INBOUND_RECV_CODE: "qvi",
    CV_CLAIMS_CODE: "claims",
    UNDEFINED: 'undefined',
    SEARCH_QULIFIER_ALL: "all",
    SEARCH_QULIFIER_START: "starts_with",
    SEARCH_QULIFIER_EQUAL: "equals",
    SEARCH_QULIFIER_CONTAIN: "contains",
    SEARCH_BY_USERID: "userId",
    SEARCH_BY_NAME: "userName",
    SEARCH_BY_OUTBOUND: "qvo",
    SEARCH_BY_INBOUND: "qvi",
    SEARCH_BY_LID: "qvl",
    SEARCH_BY_THIRD_PARTY: "qv3",
    SEARCH_BY_IMPORT: "qvb",
    SEARCH_BY_CLAIMS: "claims",
    USER_ID_PATTERN_NOSPACE: /^\s*\S+\s*$/,
    USER_ID_PATTERN_NOSPECIAL: /^[^@/\\:;<>"%&?]*$/,
    USER_ID_PATTERN_NOSPECIAL_1: /^[^@/\\:;<>"%?]*$/,
    LOCATION_ID_PATTERN: /^\w{3,10}$/,
    TRACKING_NO_PATTERN: /^\w{16,25}$/,
    PHONE_PATTERN: /^[a-zA-Z0-9][a-zA-Z0-9]{5,15}$/,
    CREATE_ACCOUNT: "CreateAccount",
    CREATE_COMPANY: "CreateCompany",
    ADD_SELECTED_IRA: "AddSelectedIRA",
    MAYBE1: "MAYBE1",
    MAYBE2: "MAYBE2",
    MAYBE3: "MAYBE3",
    FAIL: "Fail",
    VALIDATION_RESULT_KEY_1: '1',
    VALIDATION_RESULT_KEY_2: '2',
    VALIDATION_RESULT_KEY_3: '3',
    VALIDATION_RESULT_KEY_0: '0'
}
export const ApiErrorCode: any = {
    GET_LOCATIONS: "UPPLM_A1",
    INIT: "UPPLM_A2",
    GET_SESSION: "UPPLM_A3",
    SET_SESSION: "UPPLM_A4",
    CREATE_SESSION: "UPPLM_A5",
    GET_PLACARD_OPTIONS: "UPPLM_A6",
    CREATE_PLACARD_CONFIRMATION: "UPPLM_A7",
    GET_CAPTCHA_PUBLIC_KEY: "UPPLM_A7",
    CREATE_PICKUP: "UPPLM_A8",
    CLEAN_SESSION: "UPPLM_A9",
    GET_PLACARD_CONFIRMATION_STATUS: "UPPLM_A10",
    VALIDATE_CAPTCHA: "UPPLM_A11",
    GET_CONFIGURATION: "UPPLM_A12",
    GET_TRANSLATIONS: "UPPLM_A13",
    UPDATE_COMPANY_INFO: "CV_A2",
    GET_COMPANY_INFO: "CV_A1",
    GET_COMP_USER: "CV_A3",
    DELETE_COMP_USER: "CV_A4",
    CREATE_COMP_USER: "CV_A5",
    GET_COMP_SERVICES: "CV_A6",
    GET_OUTBOUND_ACCT: "CV_A7",
    UPDATE_ACCT_NICKNAME: "CV_A8",
    GET_IMPORT_ACCT: "CV_A9",
    GET_THIRD_ACCT: "CV_A10",
    GET_INBOUND_LID_ACCT: "CV_A11",
    GET_INBOUND_REC_ACCT: "CV_A12",
    DELETE_OUTBOUND_ACCT: "CV_A13",
    DELETE_IMPORT_ACCT: "CV_A14",
    DELETE_THIRD_ACCT: "CV_A15",
    DELETE_INBOUND_LID_ACCT: "CV_A16",
    DELETE_INBOUND_REC_ACCT: "CV_A17",
    GET_CLAIMS_ACCT: "CV_A18",
    DELETE_CLAIMS_ACCT: "CV_A19",
    GET_PROFILE_INFO: "CV_A20",
    GET_ACOCUNT_ELIGIBILITY: "CV_A21",
    CREATE_COMPANY_BY_ACCOUNT: "CV_A22",
    GET_ACCOUNT_DETAILS: "CV_A23",
    CREATE_COMPANY_PRIVILEGE: "CV_A24",
    CREATE_LID: "CV_A25",
    UPDATE_LID_COMPANYNAME: "CV_A26",
    UPDATE_IRA_COMPANYNAME: "CV_A27",
    GET_COMP_USER_SERVICES: "CV_A28",
    CREATE_IRA: "CV_A29",
    UPDATE_USER_SERVICE_STATUS: "CV_A30",
    GET_COMPNAY_USER_INFO: "CV_A31",
    GET_LIST_OF_USER_PRIVILEGE: "CV_A32",
    SAVE_USER_PRIVILEGE: "CV_A33",
    DELETE_USER_PRIVILEGE: "CV_A34",
    GET_ADDRESSES: "CV_A35",
    CREATE_IRA_COMPANY: "CV_A36",
    UPDATE_USER_INFO: "CV_A37",
    UPDATE_USER_ACCESS: "CV_A38",
    GET_LIST_OF_THIRD_PARTY_PRIVILEGE: "CV_A39",
    SAVE_THIRD_PARTY_PRIVILEGE: "CV_A40",
    DELETE_THIRD_PARTY_PRIVILEGE: "CV_A41",
    GET_LIST_OF_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_A42",
    SAVE_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_A43",
    DELETE_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_A44",
    GET_LIST_OF_IMPORT_ACCOUNT_PRIVILEGE: "CV_A45",
    SAVE_IMPORT_ACCOUNT_PRIVILEGE: "CV_A46",
    DELETE_IMPORT_ACCOUNT_PRIVILEGE: "CV_A47",
    DELETE_USER_PRIVILEGE_INBOUND_LID_ACCT: "CV_A48",
    SAVE_USER_PRIVILEGE_INBOUND_LID_ACCT: "CV_A49",
    UPDATE_IRA_DCO: "CV_A50",
    UPDATE_COMPANY_IRA_DCO_PRIVILEGE: "CV_A51",
    VIEW_ACCOUNT_MAIN: "CV_A52",
    SEND_INVITATION: "CV_A53",
    SEND_INVITATION_TOKEN: "CV_A54",
    ACCEPT_INVITATION: "CV_A55",
    SAVE_COMPANY_USER: "CV_A56",
    GET_LIST_OF_Claims_ACCOUNT_PRIVILEGE: "CV_A57",
    SAVE_CLAIMS_ACCOUNT_PRIVILEGE: "CV_A58",
    DELETE_CLAIMS_ACCOUNT_PRIVILEGE: "CV_A59",
    GET_PLACARD_VERIFICATION: "UPPLM_A12",
    GET_PLACARD_INFORMATION: "UPPLM_A13",
    SEND_APPROVE: "UPPLM_A14",
    GET_DASHBOARD_INFORMATION: 'UPPLM_A15',
    GET_CLIENTKEY_VALIDATION: 'UPPLM_A16',
    GET_CLIENTKEY_MATCH: 'UPPLM_A17',
    ADD_CLIENT_KEY: 'UPPLM_A17',
    GET_QVSUMMARIES: 'UPPLM_A18',
    GET_QVSUMMARIES_COOKIES: 'UPPLM_A18',
    GET_QVLIST: 'UPPLM_A18',
    GET_PICKUP_PLAN: 'UPPLM_A19',
    GET_COMMON_USER_ATTRIBUTES: 'UPPLM_A20',
    EDIT_PLACARD: 'PPAD_A23',
    GET_PLACARD_CATALOG: 'UPPLM_A21'
}

export const SessionKeys: any = {
    LOCATION_DETAILS: 'LOCATION_DETAILS',
    CONTACT_DETAILS: 'CONTACT_DETAILS',
    PLACARD_DETAILS: 'PLACARD_DETAILS',
    PICKUP_DETAILS: 'PICKUP_DETAILS',
    NOTIFICATION_DETAILS: 'NOTIFICATION_DETAILS',
    TIMEOUT: 30 //Minutes
}
export const CodeErrorCode: any = {
    UPDATE_COMPANY_INFO: "CV_C2",
    GET_COMPANY_INFO: "CV_C1",
    GET_COMP_USER: "CV_C3",
    DELETE_COMP_USER: "CV_C4",
    CREATE_COMP_USER: "CV_C5",
    GET_COMP_SERVICES: "CV_C6",
    GET_OUTBOUND_ACCT: "CV_C7",
    UPDATE_ACCT_NICKNAME: "CV_C8",
    GET_IMPORT_ACCT: "CV_C9",
    GET_THIRD_ACCT: "CV_C10",
    GET_INBOUND_LID_ACCT: "CV_C11",
    GET_INBOUND_REC_ACCT: "CV_C12",
    DELETE_OUTBOUND_ACCT: "CV_C13",
    DELETE_IMPORT_ACCT: "CV_C14",
    DELETE_THIRD_ACCT: "CV_C15",
    DELETE_INBOUND_LID_ACCT: "CV_C16",
    DELETE_INBOUND_REC_ACCT: "CV_C17",
    GET_CLAIMS_ACCT: "CV_C18",
    DELETE_CLAIMS_ACCT: "CV_C19",
    GET_PROFILE_INFO: "CV_C20",
    GET_ACOCUNT_ELIGIBILITY: "CV_C21",
    CREATE_COMPANY_BY_ACCOUNT: "CV_C22",
    GET_ACCOUNT_DETAILS: "CV_C23",
    CREATE_COMPANY_PRIVILEGE: "CV_C24",
    CREATE_LID: "CV_C25",
    UPDATE_LID_COMPANYNAME: "CV_C26",
    UPDATE_IRA_COMPANYNAME: "CV_C27",
    GET_COMP_USER_SERVICES: "CV_C28",
    CREATE_IRA: "CV_C29",
    UPDATE_USER_SERVICE_STATUS: "CV_C30",
    GET_COMPNAY_USER_INFO: "CV_C31",
    GET_LIST_OF_USER_PRIVILEGE: "CV_C32",
    SAVE_USER_PRIVILEGE: "CV_C33",
    DELETE_USER_PRIVILEGE: "CV_C34",
    GET_ADDRESSES: "CV_C35",
    CREATE_IRA_COMPANY: "CV_C36",
    UPDATE_USER_ACCESS: "CV_C38",
    GET_LIST_OF_THIRD_PARTY_PRIVILEGE: "CV_C39",
    SAVE_THIRD_PARTY_PRIVILEGE: "CV_C40",
    DELETE_THIRD_PARTY_PRIVILEGE: "CV_C41",
    GET_LIST_OF_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_C42",
    SAVE_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_C43",
    DELETE_OUTBOUND_ACCOUNT_PRIVILEGE: "CV_C44",
    GET_LIST_OF_IMPORT_ACCOUNT_PRIVILEGE: "CV_C45",
    SAVE_IMPORT_ACCOUNT_PRIVILEGE: "CV_C46",
    DELETE_IMPORT_ACCOUNT_PRIVILEGE: "CV_C47",
    DELETE_USER_PRIVILEGE_INBOUND_LID_ACCT: "CV_C48",
    SAVE_USER_PRIVILEGE_INBOUND_LID_ACCT: "CV_C49",
    UPDATE_IRA_DCO: "CV_C50",
    UPDATE_COMPANY_IRA_DCO_PRIVILEGE: "CV_A51",
    VIEW_ACCOUNT_MAIN: "CV_C52",
    UPDATE_USER_INFO: "CV_C37",
    SEND_INVITATION: "CV_C53",
    SEND_INVITATION_TOKEN: "CV_C54",
    ACCEPT_INVITATION: "CV_C55",
    SAVE_COMPANY_USER: "CV_C56",
    GET_LIST_OF_Claims_ACCOUNT_PRIVILEGE: "CV_C57",
    SAVE_CLAIMS_ACCOUNT_PRIVILEGE: "CV_C58",
    DELETE_CLAIMS_ACCOUNT_PRIVILEGE: "CV_C59",
    GET_PLACARD_CATALOG: 'UPPLM_A21'
}
export const GlobalFlags: any = {
    DISABLE_RECAPTCHA_PART: 'true'
}

export const PAGE_TITLE: any = {
    CONFIRM_PLACARD_DISPLAY_TITLE: 'Confirm Placard Display'
}

export const HTML_HEADER: any = {
    ONBORDING_HEADER: 'Create a UPS<sup>&#174;</sup> Pickup Point',
    MANAGE_UPPLOCATION_HEADER: 'Manage UPS<sup>&#174;</sup> Pickup Point Locations'
}

export const COOKIES_TO_GET: any = {
    SESSION_UPS_COM: 'session_ups_com'
}

export const ENVIRONMENTS: any = {
    Development: 'Development',
    CDE: 'CDE',
    ERPT: 'ERPT',
    MAHWAH: 'MAHWAH',
    STAGING: 'STAGING',
    SYSTEST: 'SYSTEST',
    WINDWARD: 'WINDWARD'
}

export const UPPLM_CURRENT_VERSION: string = '5.79.13';
export const RECAPTCHA_SITE_KEY_PROD: string = "6LcUGXAiAAAAADp3eTvuDdDTVHpPrfujjlUT8K1p";
export const RECAPTCHA_SITE_KEY_TEST: string = "6Leua1EiAAAAAARNqkBe-M_uonDH_V7sHABnpKn6";

export const COUNTRY_LANGUAGE = [
    { key: "US", value: 'upplm.common.usa', region: 'NA', locale: 'en_US', language: 'upplm.common.english' },
    { key: "CA", value: 'upplm.common.canada', region: 'NA', locale: 'en_CA', language: 'upplm.common.english' },
    { key: "CA", value: 'upplm.common.canada', region: 'NA', locale: 'fr_CA', language: 'upplm.common.french' },
    { key: "FR", value: 'upplm.common.france', region: 'EMEA', locale: 'fr_FR', language: 'upplm.common.french' },
    { key: "IT", value: 'upplm.common.italy', region: 'EMEA', locale: 'it_IT', language: 'upplm.common.italian' },
    { key: "DE", value: 'upplm.common.germany', region: 'EMEA', locale: 'de_DE', language: 'upplm.common.deutsch' },
    { key: "GB", value: 'upplm.common.england', region: 'EMEA', locale: 'en_GB', language: 'upplm.common.english' },
    { key: "ES", value: 'upplm.common.spain', region: 'EMEA', locale: 'es_ES', language: 'upplm.common.spanish' },
    { key: "IT", value: 'upplm.common.france', region: 'EMEA', locale: 'en_IT', language: 'upplm.common.english' },
    { key: "DE", value: 'upplm.common.germany', region: 'EMEA', locale: 'en_DE', language: 'upplm.common.english' },
    { key: "ES", value: 'upplm.common.spain', region: 'EMEA', locale: 'en_ES', language: 'upplm.common.english' },
    { key: "FR", value: 'upplm.common.france', region: 'EMEA', locale: 'en_FR', language: 'upplm.common.english' }
];

export const CONTINENTAL_REGIONS_FULL = [
    { key: 'EMEA', value: 'Europe, Middle East, Africa' },
    { key: 'APAC', value: 'Asia, Pacific' },
    { key: 'LATAM', value: 'Latin America' },
    { key: 'NA', value: 'USA and Canada' }
]

export const CONTINENTAL_REGIONS: any = {
    EMEA: 'EMEA',
    APAC: 'APAC',
    LATAM: 'LATAM',
    NA: 'NA',
}

export const SUPPORT_PHONE_NUMBERS = [
    { countryCode: 'GB', phoneNumber: '+442079490090' },
    { countryCode: 'DE', phoneNumber: '+496966308033' },
    { countryCode: 'FR', phoneNumber: '+33170200038' },
    { countryCode: 'ES', phoneNumber: '+34913496513' },
    { countryCode: 'IT', phoneNumber: '+390245279018' },
    { countryCode: 'CA', phoneNumber: '1-844-4UPS-LAB (1-844-487-7522)' },
    { countryCode: 'US', phoneNumber: '1-844-4UPS-LAB (1-844-487-7522)' },
]

export const SUPPORTED_LANGUAGES = [
    { key: "en_US", value: "en_US" },
    { key: "en_CA", value: "en_CA" },
    { key: "fr_CA", value: "fr_CA" },
    { key: "es_ES", value: "es_ES" },
    { key: "fr_FR", value: "fr_FR" },
    { key: "it_IT", value: "it_IT" },
    { key: "de_DE", value: "de_DE" },
    { key: "en_GB", value: "en_GB" },
    { key: "en_FR", value: "en_FR" },
    { key: "en_DE", value: "en_DE" },
    { key: "en_IT", value: "en_IT" },
    { key: "en_ES", value: "en_ES" }
];

export const CAC_FIELD_TRANSLATION = [
    { id: 'country', key: 'upplm.cac.country' },
    { id: 'name', key: 'upplm.cac.name' },
    { id: 'address1', key: 'upplm.cac.address' },
    { id: 'city', key: 'upplm.cac.city' },
    { id: 'state', key: 'upplm.cac.state' },
    { id: 'postal', key: 'upplm.cac.postal' }
];

export const CAC_SUPPORTED_COUNTRY = [
    { key: "US", value: 'upplm.common.usa' },
    { key: "CA", value: 'upplm.common.canada' },
    { key: "FR", value: 'upplm.common.france' },
    { key: "IT", value: 'upplm.common.italy' },
    { key: "DE", value: 'upplm.common.germany' },
    { key: "GB", value: 'upplm.common.england' },
    { key: "ES", value: 'upplm.common.spain' }
];

export const EMAIL_LANGUAGE_POSVALUE = [
    { countryCode: 'US', language: 'upplm.common.english'},
    { countryCode: 'CA', language: 'upplm.common.englishfrench'},
    { countryCode: 'FR', language: 'upplm.common.french' },
    { countryCode: 'IT', language: 'upplm.common.italian'},
    { countryCode: 'DE', language: 'upplm.common.deutsch'},
    { countryCode: 'GB', language: 'upplm.common.english'},
    { countryCode: 'ES', language: 'upplm.common.spanish' }
];

export const CAC_FIELD_TYPE_ERROR = [

    { id: 'required', field: 'country', key: 'upplm.cac.error.countryrequired' },
    { id: 'required', field: 'name', key: 'upplm.cac.error.namerequired' },
    { id: 'required', field: 'city', key: 'upplm.cac.error.cityrequired' },
    { id: 'required', field: 'address1', key: 'upplm.cac.error.addressrequired' },
    { id: 'required', field: 'state', key: 'upplm.cac.error.staterequired' },
    { id: 'required', field: 'postal', key: 'upplm.cac.error.postalrequired' },

    { id: 'maxLength', field: 'country', key: 'upplm.cac.error.countrymaxlength' },
    { id: 'maxLength', field: 'name', key: 'upplm.cac.error.namemaxlength' },
    { id: 'maxLength', field: 'city', key: 'upplm.cac.error.citymaxlength' },
    { id: 'maxLength', field: 'address1', key: 'upplm.cac.error.addressmaxlength' },
    { id: 'maxLength', field: 'state', key: 'upplm.cac.error.statemaxlength' },
    { id: 'maxLength', field: 'postal', key: 'upplm.cac.error.postalmaxlength' },

    { id: 'invalid', field: 'name', key: 'upplm.cac.error.nameisinvalid' },
    { id: 'invalid', field: 'country', key: 'upplm.cac.error.countryisinvalid' },
    { id: 'invalid', field: 'city', key: 'upplm.cac.error.cityisinvalid' },
    { id: 'invalid', field: 'address1', key: 'upplm.cac.error.addressisinvalid' },
    { id: 'invalid', field: 'state', key: 'upplm.cac.error.stateisinvalid' },
    { id: 'invalid', field: 'postal', key: 'upplm.cac.error.postalisinvalid' },

    { id: 'pattern', field: 'country', key: 'upplm.cac.error.countryformatisinvalid' },
    { id: 'pattern', field: 'name', key: 'upplm.cac.error.nameformatisinvalid' },
    { id: 'pattern', field: 'city', key: 'upplm.cac.error.cityformatisinvalid' },
    { id: 'pattern', field: 'address1', key: 'upplm.cac.error.addressformatisinvalid' },
    { id: 'pattern', field: 'state', key: 'upplm.cac.error.stateformatisinvalid' },
    { id: 'pattern', field: 'postal', key: 'upplm.cac.error.postalformatisinvalid' },

    { id: 'invalidFormat', field: 'country', key: 'upplm.cac.error.countryformatisinvalid' },
    { id: 'invalidFormat', field: 'name', key: 'upplm.cac.error.nameformatisinvalid' },
    { id: 'invalidFormat', field: 'city', key: 'upplm.cac.error.cityformatisinvalid' },
    { id: 'invalidFormat', field: 'address1', key: 'upplm.cac.error.addressformatisinvalid' },
    { id: 'invalidFormat', field: 'state', key: 'upplm.cac.error.stateformatisinvalid' },
    { id: 'invalidFormat', field: 'postal', key: 'upplm.cac.error.postalformatisinvalid' },
];

export const CAC_CONTENT_TRANSLATION = [
    { key: 'upplm.cac.country', cacKey: 'country' },
    { key: 'upplm.cac.nickname', cacKey: 'nickname' },
    { key: 'upplm.cac.name', cacKey: 'name' },
    { key: 'upplm.cac.contactName', cacKey: 'contactName' },
    { key: 'upplm.cac.address', cacKey: 'address' },
    { key: 'upplm.cac.address1', cacKey: 'address1' },
    { key: 'upplm.cac.address2', cacKey: 'address2' },
    { key: 'upplm.cac.address3', cacKey: 'address3' },
    { key: 'upplm.cac.address1Placeholder', cacKey: 'address1Placeholder' },
    { key: 'upplm.cac.address2Placeholder', cacKey: 'address2Placeholder' },
    { key: 'upplm.cac.address3Placeholder', cacKey: 'address3Placeholder' },
    { key: 'upplm.cac.city', cacKey: 'city' },
    { key: 'upplm.cac.state', cacKey: 'state' },
    { key: 'upplm.cac.postal', cacKey: 'postal' },
    { key: 'upplm.cac.isResidential', cacKey: 'isResidential' },
    { key: 'upplm.cac.yes', cacKey: 'yes' },
    { key: 'upplm.cac.no', cacKey: 'no' },
    { key: 'upplm.cac.validationFailure', cacKey: 'validationFailure' },
    { key: 'upplm.cac.updateAddress', cacKey: 'updateAddress' },
    { key: 'upplm.cac.email', cacKey: 'email' },
    { key: 'upplm.cac.countryDial', cacKey: 'countryDial' },
    { key: 'upplm.cac.phone', cacKey: 'phone' },
    { key: 'upplm.cac.extension', cacKey: 'extension' },
    { key: 'upplm.cac.phoneType', cacKey: 'phoneType' },
    { key: 'upplm.cac.fax', cacKey: 'fax' },
    { key: 'upplm.cac.locationId', cacKey: 'locationId' },
    { key: 'upplm.cac.selectOne', cacKey: 'selectOne' },
    { key: 'upplm.cac.isRequired', cacKey: 'isRequired' },
    { key: 'upplm.cac.invalidFormat', cacKey: 'invalidFormat' },
    { key: 'upplm.cac.minLength', cacKey: 'minLength' },
    { key: 'upplm.cac.maxLength', cacKey: 'maxLength' },
]

export interface ClientKeyValues {
    clientKeyAlias: string;
    clientKeyId: string;
}

export const EDIT_SECTIONS: any = {
    PLACARD_DETAILS: 'editplacarddetails',
    LOCATION_DETAILS: 'editlocationdetails',
    PICKUP_DETAILS: 'editpickupdetails',
    CONTACT_DETAILS: 'editcontactdetails',
    NOTIFICATION_DETAILS: 'editnotificationdetails',
    PLACARD_LOCATION: 'editplacardlocationdetails',
    PLACARD_VERIFICATION: 'editplacardverification'
}

export const TRANSACTION_SRC: string = 'P9';

export const A4_PLACARD_SIZE: string = 'A4';
export const A4_PLACARD_SIZE_KEY: string = '01';

export const PLACARD_SIZE_KEY = [
    { key: '01', value: '8.5 in. x 11 in. Portrait' },
    { key: '01', value: '8.5 in. x 11 in. Portrait / A4' },
    { key: '02', value: '5 in. x 7 in. Portrait' },
    { key: '03', value: '5 in. x 7 in. Landscape' }
];

export const PLACARD_TYPE_KEY = [
    { key: '01', value: 'LAB SPECIMEN' },
    { key: '02', value: 'NON-LAB' }
];

export const SEARCH_CRITERIA = [
    { SEARCH_VALUE_KEY: 'Placard ID', SEARCH_QUERY_BY: 'placardId', TEXT_SEARCH_CRITERIA: 'upplm.common.placardid' },
    { SEARCH_VALUE_KEY: 'Company Name', SEARCH_QUERY_BY: 'companyName', TEXT_SEARCH_CRITERIA: 'upplm.common.companyname' },
    { SEARCH_VALUE_KEY: 'Address', SEARCH_QUERY_BY: 'address', TEXT_SEARCH_CRITERIA: 'upplm.common.address' },
    { SEARCH_VALUE_KEY: 'Client Key Nickname', SEARCH_QUERY_BY: 'clientNickname', TEXT_SEARCH_CRITERIA: 'upplm.common.clientkeynickname' }
]

export const SEARCH_VALUE_KEY: any = {
    PLACARD_ID: 'placardId',
    COMPANY_NAME: 'companyName',
    ADDRESS: 'address',
    CLIENT_KEY_NICKNAME: 'clientNickname',
    STATUS: 'Status',
    DEFAULT: 'Select One'
};

export const TRANSLATE_CRITERIA_PARAMETER: any = {
    PARAMETER_1: '%[_1_]%',
    PARAMETER_2: '%[_2_]%',
    PARAMETER_3: '%[_3_]%'
}

export const UPS_PICKUP_POINT: string = 'UPS Pickup Point'
